import { useEffect } from 'react';

// Pages keep the previous page's title unless they set their own. Keep titles
// brand-neutral: resellers see them on their own domain.
const useDocumentTitle = (title: string) => {
	useEffect(() => {
		document.title = title;
	}, [title]);
};

export default useDocumentTitle;
